import { Typography } from "@mui/joy";
import { Paper, Tab, Tabs } from "@mui/material";
import { Box } from "@mui/system";
import { ReactElement, SyntheticEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { talentTab } from "../constants";
import TalentAvatar from "../hooks/talent/talentsList/talentAvatar";
import TalentLedger from "../hooks/talentLedger/talentLedger";
import { TalentJobs } from "../hooks/talents/talentJobs";
import { TalentTimers } from "../hooks/talents/talentTimers";
import { setTabIndex } from "../redux/appStatus/appStatusActions";
import { tabIndexSelector } from "../redux/appStatus/appStatusSelector";
import { selectedTalentID } from "../redux/filmsReducer";
import { useTalent } from "../redux/talent/talentHooks";
import FormTalent from "../hooks/talent/formTalent";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function TalentRoute(): ReactElement {
  const tabIndex = useSelector(tabIndexSelector(talentTab)) ?? 0;
  const dispatch = useDispatch();
  const params = useParams();
  const _talentIDProps = parseInt(params.id ?? "");
  const _talentIDRedux = useSelector(selectedTalentID);

  const talentID = _talentIDRedux ?? _talentIDProps;
  const { talent } = useTalent(talentID);

  const handleTabIndexChange = (
    e: SyntheticEvent<Element, Event>,
    v: number
  ) => {
    dispatch(setTabIndex(talentTab, v));
  };

  function getTabContent() {
    switch (tabIndex) {
      case 0:
        return (
          <Box sx={{ display: "flex", flexGrow: 1 }}>
            <Paper sx={{ maxWidth: 600 }}>
              <FormTalent talent={talent} header={false} />
            </Paper>
          </Box>
        );
      case 1:
        return (
          <Box sx={{ display: "flex", flexGrow: 1 }}>
            <TalentJobs />
          </Box>
        );
      case 2:
        return (
          <Box sx={{ display: "flex", flexGrow: 1 }}>
            <TalentTimers />
          </Box>
        );
      case 3:
        return (
          <Box sx={{ display: "flex", flexGrow: 1 }}>
            <TalentLedger withSummary />
          </Box>
        );
      default:
        return <div>Coming very soon 🙂</div>;
    }
  }

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <Paper
        sx={(t) => ({
          position: "sticky",
          top: 0,
          borderRadius: 0,
          zIndex: 99,
        })}
      >
        <Typography
          startDecorator={<TalentAvatar talent={talent} />}
          level="h6"
          sx={{ p: 1 }}
        >
          {talent?.fullName()}
        </Typography>
        <Tabs
          value={tabIndex}
          onChange={handleTabIndexChange}
          aria-label="basic tabs example"
        >
          <Tab value={0} label="Info" />
          <Tab value={1} label="Invoices" />
          <Tab value={2} label="Timers" />
          <Tab value={3} label="Virtual Ledger" />
        </Tabs>
      </Paper>
      <Box sx={{ p: 2, flexGrow: 1, display: "flex" }}>{getTabContent()}</Box>
    </Box>
  );
}
